"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPONENT_FUNCTION_STATES_NAME = exports.MODE_STATES_NAME = exports.NETSTATS_NAME = exports.DESIGN_CONFIG_NAME = exports.RESOLVED_COMPONENTS_NAME = exports.PROJECT_MODEL_NAME = void 0;
exports.PROJECT_MODEL_NAME = 'project.model.json';
exports.RESOLVED_COMPONENTS_NAME = 'resolved-components.json';
exports.DESIGN_CONFIG_NAME = 'design-configuration.json';
exports.NETSTATS_NAME = 'netstats.json';
exports.MODE_STATES_NAME = 'mode-states.json';
exports.COMPONENT_FUNCTION_STATES_NAME = 'component-function-states.json';
//# sourceMappingURL=filenames.js.map